import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginContext } from "../../Contexts/LoginContext";
import api from "../../services/api";
import RoleSelectionModal from "../RoleSelectionModal";

function GoogleAuthentication() {
  const navigate = useNavigate();
  const { login, loggedIn } = useLoginContext();

  const [showRoleModal, setShowRoleModal] = useState(false);
  const [googleTempToken, setGoogleTempToken] = useState("");

  useEffect(() => {
    if (loggedIn) navigate("/");
  }, [loggedIn, navigate]);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const token = credentialResponse.credential;
      setGoogleTempToken(token);

      const response = await api.post("/auth/google", { token });

      if (response.status === 200 && response.data.token) {
        login(response.data.token);
        return;
      }

      if (response.data.needRole === true) {
        setShowRoleModal(true);
      }
    } catch (error) {
      console.error("Google login error:", error);
    }
  };

  const submitRoleToBackend = async (role) => {
    try {
      const response = await api.post("/auth/google/set-role", {
        token: googleTempToken,
        role,
      });

      if (response.status === 200 && response.data.token) {
        login(response.data.token);
      }
    } catch (error) {
      console.error("Role submit error:", error);
    } finally {
      setShowRoleModal(false);
    }
  };

  return (
    <>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
        {/* Google Login stays isolated → prevents flicker */}
        <div className="flex justify-center">
              <GoogleLogin 
                onSuccess={handleGoogleSuccess} 
                onError={() => console.log("Login failed")} 
              />
            </div>
      </GoogleOAuthProvider>

      {/* Render modal using portal → NO FLICKER */}
      {showRoleModal && (
        <RoleSelectionModal
          onSelect={submitRoleToBackend}
          onClose={() => setShowRoleModal(false)}
        />
      )}
    </>
  );
}

export default GoogleAuthentication;
